import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const BookLaunchEvents = () => <EventCategoryPage config={EVENT_CATEGORIES['book-launches']} data-id="element-9845" data-mp="3sr8ngneuounh" />;
export default BookLaunchEvents;